import api from '../../../../../../admin/api/api';

export default {
    namespaced: true,
    state: {
        attachments: [],
        hiddenList: false
    },
    mutations: {
        setAttachment(state, attachments){
            state.attachments = attachments;
        },
        addAttachment(state, attachment){
            const existAttachment = _.findIndex(state.attachments, ['id', attachment.id]);

            if (!(existAttachment + 1)) {
                state.attachments.push(attachment);
            }
        },
        spliceAttachments(state, id){
            const attachmentIndex = state.attachments.findIndex(attachments => attachments.id == id);

            if (attachmentIndex + 1) {
                state.attachments.splice(attachmentIndex, 1);
            }
        },
        switchList(state){
            state.hiddenList = !state.hiddenList;
        },
    },
    actions: {
        getAttachments({commit, rootState}){
            api.get('/attachments/' + rootState.consultation.id).then(response => {
                commit('setAttachment', response.data.attachments);
            });
        },
        postAttachment({commit, rootState}, data){
            api.post('/attachments/' + rootState.consultation.id + '/upload', data,  {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(response => {
                commit('addAttachment', response.data);
            }).catch(error => {
                ErrorAlert.$emit('errorMessage', error.response.data.errors.file[0]);
            });
        },
        deleteAttachment({commit}, attachmentId){
            api.post('/attachments/delete', { id: attachmentId }).then(response => {
                commit('spliceAttachments', response.data.id);
            }).catch(error => {
                alert(error);
            });
        }
    }
}
